import { FunctionComponent } from 'react';

import Icon from '../../../DataDisplay/Icon/Icon';
import ProgressBar from '../../../DataDisplay/ProgressBar/ProgressBar';

import styles from './Step.module.scss';

export type StepProps = {
  isFirst?: boolean;
  isLast?: boolean;
  isActive: boolean;
  hasError?: boolean;
  percentageComplete: number;
  isDisabled?: boolean;
  number: number;
  label: string;
  onClick: (step: number) => void;
};

type FC = FunctionComponent<StepProps>;

const Step: FC = (props: StepProps) => {
  const { isActive, hasError = false, percentageComplete = 0, isLast = false, number, onClick } = props;

  return (
    <div className={styles.container} style={{ width: getContainerWidth() }}>
      <div
        className={[styles.step, styles[getActiveClass()], styles[getErrorClass()]].join(' ')}
        onClick={() => onClick(number)}
        role="button"
        aria-hidden
      >
        {percentageComplete >= 100 ? <Icon icon="check" size="xsm" color="primary-light" /> : number}
      </div>
      {!isLast && <ProgressBar percentComplete={percentageComplete} />}
    </div>
  );

  function getErrorClass() {
    return hasError ? 'error' : '';
  }

  function getActiveClass() {
    if (isActive) return 'active';

    return percentageComplete >= 100 ? 'complete' : '';
  }

  function getContainerWidth() {
    return isLast ? '' : '100%';
  }
};

export default Step;
